import { memo, useCallback } from 'react'

import { AutoDeleteOutlined } from '@mui/icons-material'
import { Divider, ListItemIcon, MenuItem, Typography } from '@mui/material'
import { VideoObject } from '@nativewaves/nw-cloud-sdk/content'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { MenuItemCopyId, MenuItemDelete } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useVideoObjectDeleteMutation } from 'hooks/mutations/content'

const RowActionsRaw = ({ row, onClose, onClick }: RowActionsProps<VideoObject>) => {
  const { t } = useTranslation(['common', 'domain'])
  const { enqueueSnackbar } = useSnackbar()

  const { mutate: deleteVideoObject } = useVideoObjectDeleteMutation()

  const handleDeleteVideoObject = useCallback(() => {
    onClose()

    deleteVideoObject(
      { videoId: row.original.id },
      {
        onSuccess: () =>
          enqueueSnackbar(t('domain:Workspace.Video.nameDelete', { name: row.original.name }), { variant: 'success' }),
        onError: () => {
          enqueueSnackbar(t('somethingWentWrong'), { variant: 'error' })
        },
      },
    )
  }, [deleteVideoObject, enqueueSnackbar, onClose, row.original.id, row.original.name, t])

  const handleLifecycleVideoStream = useCallback(() => {
    onClose()
    onClick?.(row)
  }, [onClick, onClose, row])

  return (
    <>
      <MenuItem onClick={handleLifecycleVideoStream}>
        <ListItemIcon>
          <AutoDeleteOutlined />
        </ListItemIcon>
        <Typography sx={{ width: '100%' }}>{t('domain:Workspace.Video.setLifecyclePolicy', { count: 1 })}</Typography>
      </MenuItem>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <Divider sx={{ my: 1 }} component="li" />
      <MenuItemDelete onConfirm={handleDeleteVideoObject} />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
